import { useQuery } from 'react-query'
import { ShifaImplementationUpdateModalForm } from './ShifaImplementationUpdateModalForm'
import { isNotEmpty, QUERIES } from '../../../../../_metronic/helpers'
import { useListView } from '../core/ListViewProvider'
import {getSites} from '../core/_requests'

const ShifaImplementationUpdateModalFormWrapper = () => {
    const { itemIdForUpdate, setItemIdForUpdate } = useListView()
    const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

    const {
        isLoading,
        data: shifaImplementation,
        error,
    } = useQuery(
        `shifa-implementation-${itemIdForUpdate}`,
        () => {
            return getSites(`$id=${itemIdForUpdate}`)
              .then((res) => res != undefined && res.data != undefined ? res?.data[0] : undefined);
        },
        {
            cacheTime: 0,
            enabled: enabledQuery,
            onError: (err) => {
                setItemIdForUpdate(undefined)
                console.error(err)
            },
        }
    )

    if (!itemIdForUpdate) return null

    if (!isLoading && !error && shifaImplementation) {
        return <ShifaImplementationUpdateModalForm shifaImplementation={shifaImplementation} />
    }

    if (!isLoading && !error && !shifaImplementation) {
        // If no data exists, pass an empty object or handle it in the form
        return <ShifaImplementationUpdateModalForm shifaImplementation={{ siteId: itemIdForUpdate }} />
    }

    return null
}

export { ShifaImplementationUpdateModalFormWrapper }
